// src/components/controls/DataFilter.jsx
import React, { useState } from 'react';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { RefreshCcw } from 'lucide-react';

const DataFilter = ({ onFilterChange }) => {
  const [filters, setFilters] = useState({
    temperature: { min: '', max: '' },
    humidity: { min: '', max: '' },
    pressure: { min: '', max: '' }
  });

  const handleFilterChange = (metric, bound, value) => {
    const newFilters = {
      ...filters,
      [metric]: {
        ...filters[metric],
        [bound]: value
      }
    };
    setFilters(newFilters);
    onFilterChange(newFilters);
  };

  const metrics = [
    { key: 'temperature', label: 'Temperature', unit: '°C' },
    { key: 'humidity', label: 'Humidity', unit: '%' },
    { key: 'pressure', label: 'Pressure', unit: 'hPa' }
  ];

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center justify-between">
          <span>Data Filters</span>
          <Button
            variant="outline"
            size="sm"
            onClick={() => {
              const clearedFilters = {
                temperature: { min: '', max: '' },
                humidity: { min: '', max: '' },
                pressure: { min: '', max: '' }
              };
              setFilters(clearedFilters);
              onFilterChange(null);
            }}
          >
            <RefreshCcw className="mr-2 h-4 w-4" />
            Reset Filters
          </Button>
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-6">
          {metrics.map(({ key, label, unit }) => (
            <div key={key} className="space-y-2">
              <div className="text-sm font-medium text-gray-700">{label}</div>
              <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                  <label htmlFor={`${key}-min`} className="text-sm text-gray-500">
                    Minimum {unit}
                  </label>
                  <input
                    id={`${key}-min`}
                    type="number"
                    value={filters[key].min}
                    onChange={(e) => handleFilterChange(key, 'min', e.target.value)}
                    className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder={`Min ${unit}`}
                  />
                </div>
                <div className="space-y-2">
                  <label htmlFor={`${key}-max`} className="text-sm text-gray-500">
                    Maximum {unit}
                  </label>
                  <input
                    id={`${key}-max`}
                    type="number"
                    value={filters[key].max}
                    onChange={(e) => handleFilterChange(key, 'max', e.target.value)}
                    className="w-full rounded-md border border-gray-300 px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder={`Max ${unit}`}
                  />
                </div>
              </div>
            </div>
          ))}
        </div>
      </CardContent>
    </Card>
  );
};

export default DataFilter;